import { render, staticRenderFns } from "./NexoTransactionList.vue?vue&type=template&id=8e458dca&"
import script from "./NexoTransactionList.vue?vue&type=script&lang=js&"
export * from "./NexoTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./NexoTransactionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports